import { Form, FormItemProps } from 'antd';
import { normalizeValues } from 'utils/filter';

export const FormItemForFilterValues = (props: FormItemProps) => {
  return <Form.Item {...props} normalize={normalizeValues} noStyle></Form.Item>;
};
